/* 🤖 this file was generated by svg-to-ts */
export const matIconPersonAddAlt1: {
  name: 'person-add-alt-1';
  data: string;
} = {
  name: 'person-add-alt-1',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13 8c0-2.21-1.79-4-4-4S5 5.79 5 8s1.79 4 4 4 4-1.79 4-4zm-2 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM1 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4zm2 0c.2-.71 3.3-2 6-2 2.69 0 5.78 1.28 6 2H3zm17-3v-3h3v-2h-3V7h-2v3h-3v2h3v3h2z"/></svg>`
};
